module.exports = __webpack_public_path__ + "static/media/rocket.c8d7fb5b.svg";